import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import BAFrontDeskList from './components/BAFrontDeskList';

const { Cell } = ResponsiveGrid;

const BAFrontDesk = () => (
  // <ResponsiveGrid gap={20}>
  //   <Cell colSpan={12}>
  //     <PageHeader
  //       title="BA系統前台"
  //       breadcrumbs={[
  //         {
  //           name: 'BA系統前台',
  //         },
  //         {
  //           name: 'BA系統前台',
  //         },
  //       ]}
  //     />
  //   </Cell>

  //   <Cell colSpan={12}>
  //     <BAFrontDeskList />
  //   </Cell>
  // </ResponsiveGrid>
  <BAFrontDeskList />
);

export default BAFrontDesk;
